module.exports = __webpack_public_path__ + "img/intelligent-security-solutionsimg-3.047e01fd.png";